export const header = {
    matching: 'Matching',
    messages: 'Nachrichten',
    projects: 'Projekte',
    releaseNotes: 'Versionshinweise',
    savedSearch: 'Meine Suchen',
    talentSearch: 'Talentsuche',
};
